module.exports = __webpack_public_path__ + "img/indu_list_rank.a745e8df.png";